import React, { useRef } from 'react';

const formatDate = (y, m, d) => {
  if (!y && !m && !d) return '';
  const paddedYear = y ? y.padStart(4, '0') : '';
  const paddedMonth = m ? m.padStart(2, '0') : '';
  const paddedDay = d ? d.padStart(2, '0') : '';
  return `${paddedYear}-${paddedMonth}-${paddedDay}`;
};

const DateInput = ({ value, onChange, onBlur, className }) => {
  const dayRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);

  const [y, m, d] = value ? value.split('-') : ['', '', ''];
  const year = y ? String(parseInt(y, 10)) : '';
  const month = m ? String(parseInt(m, 10)) : '';
  const day = d ? String(parseInt(d, 10)) : '';

  const handleChange = (field) => (e) => {
    const raw = e.target.value.replace(/\D/g, '');
    const val = field === 'year' ? raw : raw.slice(0, 2);

    let nextYear = field === 'year' ? val : year;
    let nextMonth = field === 'month' ? val : month;
    let nextDay = field === 'day' ? val : day;

    if (field === 'year' && val.length > 0) {
      if (!nextMonth) nextMonth = '01';
      if (!nextDay) nextDay = '01';
    }

    if (field === 'day' && val.length >= 2) {
      monthRef.current?.focus();
    }
    if (field === 'month' && val.length >= 2) {
      yearRef.current?.focus();
    }

    onChange(formatDate(nextYear, nextMonth, nextDay));
  };

  const handleBlur = () => {
    const currentDay = dayRef.current?.value.replace(/\D/g, '') || '';
    const currentMonth = monthRef.current?.value.replace(/\D/g, '') || '';
    const currentYear = yearRef.current?.value.replace(/\D/g, '') || '';

    let nextYear = currentYear;
    let nextMonth = currentMonth;
    let nextDay = currentDay;

    if (nextYear && !nextMonth) {
      nextMonth = '01';
    }
    if ((nextYear || nextMonth) && !nextDay) {
      nextDay = '01';
    }

    const formatted = formatDate(nextYear, nextMonth, nextDay);
    if (formatted !== value) {
      onChange(formatted);
    }
    if (onBlur) {
      onBlur(formatted);
    }
  };

  const handleClick = (e) => {
    if (e.target === e.currentTarget) {
      yearRef.current?.focus();
    }
  };

  return (
    <div
      className={`flex items-center rounded bg-white ${className || ''}`}
      onClick={handleClick}
    >
      <input
        ref={dayRef}
        type="text"
        inputMode="numeric"
        placeholder="DD"
        maxLength={2}
        value={day}
        onChange={handleChange('day')}
        onBlur={handleBlur}
        className="w-10 p-1 bg-transparent border-0 outline-none text-center rounded-l"
      />
      <span className="text-gray-400 select-none text-sm leading-none">/</span>
      <input
        ref={monthRef}
        type="text"
        inputMode="numeric"
        placeholder="MM"
        maxLength={2}
        value={month}
        onChange={handleChange('month')}
        onBlur={handleBlur}
        className="w-10 p-1 bg-transparent border-0 outline-none text-center"
      />
      <span className="text-gray-400 select-none text-sm leading-none">/</span>
      <input
        ref={yearRef}
        type="text"
        inputMode="numeric"
        placeholder="YYYY"
        maxLength={4}
        value={year}
        onChange={handleChange('year')}
        onBlur={handleBlur}
        className="w-14 p-1 bg-transparent border-0 outline-none text-center rounded-r"
      />
    </div>
  );
};

export default DateInput;